export default ({ minScrollHeight, minScrollWidth }) => ({
  chart: {
    scrollablePlotArea: {
      minHeight: minScrollHeight,
      minWidth: minScrollWidth
    }
  }
});
